import { NavigationLinkProps } from './types';

import { classNames } from '@/shared/lib/classNames/classNames';

export const NavigationLink = ({
  href,
  label,
  subLinks,
  icon,
}: NavigationLinkProps) => (
  <li>
    <a
      itemProp="url"
      href={`${href}`}
      className={classNames({
        cls: 'hover:bg-surface-base-blur flex h-12 w-[244px] cursor-pointer gap-2 rounded-lg p-3 tracking-[-0.016rem] max-sm:h-5 max-sm:px-2 max-sm:py-0 max-sm:text-sm max-sm:tracking-[-0.014rem]',
        mods: {
          '!h-full': !subLinks,
        },
      })}
    >
      <span className="max-sm:hidden">{icon}</span>
      <span itemProp="name">{label}</span>
    </a>
    {subLinks && (
      <div className="flex flex-col max-sm:mt-3 max-sm:gap-2">
        {subLinks.map(({ href, label }, index) => (
          <a
            itemProp="url"
            href={`${href}`}
            key={index}
            className="text-text-base-secondary hover:text-text-base-primary mb-2 ml-11 text-sm leading-[1.125rem] max-sm:mb-0 max-sm:ml-4"
          >
            <span itemProp="name">{label}</span>
          </a>
        ))}
      </div>
    )}
  </li>
);
